import { Toaster as ChakraToaster, Flex, Portal, Spinner, Stack, Toast } from '@chakra-ui/react';
import { toasterOriginal, toasterCopy, notification } from './utils';

export function Toaster() {
  return (
    <Portal>
      <ChakraToaster toaster={toasterOriginal} insetInline={{ mdDown: '4' }}>
        {(toast) => (
          <Toast.Root width={{ md: 'sm' }}>
            {toast.type === 'loading' ? (
              <Spinner size="sm" color="blue.solid" />
            ) : (
              <Toast.Indicator />
            )}
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
            </Stack>
            {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
            {toast.closable && <Toast.CloseTrigger />}
          </Toast.Root>
        )}
      </ChakraToaster>
      <ChakraToaster toaster={notification} insetInline={{ mdDown: '4' }}>
        {(toast) => (
          <Toast.Root width={{ md: 'sm' }}>
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
            </Stack>
            {toast.closable && <Toast.CloseTrigger cursor="pointer" />}
          </Toast.Root>
        )}
      </ChakraToaster>
      <ChakraToaster toaster={toasterCopy} insetInline={{ mdDown: '4' }}>
        {(toast) => (
          <Toast.Root
            w="auto"
            px="3"
            py="2.5"
            borderRadius="full"
            boxShadow="none"
            bg="blackAlpha.80"
          >
            <Flex alignItems="center" gap="2">
              {toast.type === 'loading' ? (
                <Spinner size="sm" color="white" />
              ) : toast.type === 'success' ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M11.9453 2.99018H5.53027C4.01089 2.99018 2.7792 4.22189 2.7792 5.7413V12.1562C1.58887 12.0975 0.945312 11.3998 0.945312 10.1596V3.15694C0.945312 1.86018 1.64923 1.15625 2.94596 1.15625H9.94846C11.1886 1.15625 11.8865 1.79982 11.9453 2.99018Z"
                    fill="#00B600"
                  />
                  <path
                    d="M5.94527 4.15625H12.9454C14.2419 4.15625 14.9453 4.85992 14.9453 6.15621V13.1563C14.9453 14.4528 14.2419 15.1562 12.9454 15.1562H5.94527C4.64876 15.1562 3.94531 14.4528 3.94531 13.1563V6.15621C3.94531 4.85992 4.64899 4.15625 5.94527 4.15625Z"
                    fill="#00B600"
                  />
                </svg>
              ) : null}
              {toast.type === 'loading' ? (
                <Toast.Title color="white" fontSize="xs" fontWeight="medium">
                  Copying...
                </Toast.Title>
              ) : toast.type === 'error' ? (
                <Toast.Title color="fg.error" fontSize="xs" fontWeight="medium">
                  Copy Error
                </Toast.Title>
              ) : (
                <Toast.Title color="white" fontSize="xs" fontWeight="medium">
                  {toast.title || 'Copied'}
                </Toast.Title>
              )}
            </Flex>
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
}
